import { createActionTypes } from 'utils/action/actionTypes';

export const SEND_CONTACT_EMAIL = createActionTypes('SEND_CONTACT_EMAIL');
